import { useEffect, useState } from 'react';

import { CoreFormFieldSelect } from '@bambi/component-library/src/components/forms/fields/CoreFormFieldSelect';
import { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { FilterPopover } from 'src/common/primitives/FilterPopover/FilterPopover';
import { FilterPopoverTrigger } from 'src/common/primitives/FilterPopover/FilterPopoverTrigger';

import {
  setFilterHasEmailedPaymentLink,
  setFilterHasPaymentLink,
  TriStateFilter,
} from '../invoice.slice';

export function PaymentLinkFilter() {
  const dispatch = useAppDispatch();

  const hasPaymentLink = useAppSelector(
    (state) => state.invoice.filterHasPaymentLink
  );
  const hasEmailedPaymentLink = useAppSelector(
    (state) => state.invoice.filterHasEmailedPaymentLink
  );

  const [selectedValue, setSelectedValue] =
    useState<TriStateFilter>(hasPaymentLink);
  const [selectedValueWithEmail, setSelectedValueWithEmail] =
    useState<TriStateFilter>(hasEmailedPaymentLink);

  useEffect(() => {
    setSelectedValue(hasPaymentLink);
    setSelectedValueWithEmail(hasEmailedPaymentLink);
  }, [hasPaymentLink, hasEmailedPaymentLink]);

  return (
    <FilterPopover
      triggerElement={<FilterPopoverTrigger label="Payment Link" />}
      onApply={() => {
        dispatch(setFilterHasPaymentLink(selectedValue));
        dispatch(setFilterHasEmailedPaymentLink(selectedValueWithEmail));
      }}
    >
      <div className="flex flex-col gap-2">
        <HasPaymentLinkSelect
          value={selectedValue}
          onChange={setSelectedValue}
        />
        <HasPaymentLinkWithEmailSelect
          value={selectedValueWithEmail}
          onChange={setSelectedValueWithEmail}
        />
      </div>
    </FilterPopover>
  );
}

const options: SelectOption<TriStateFilter>[] = [
  {
    label: 'Yes',
    value: 'yes',
  },
  {
    label: 'No',
    value: 'no',
  },
  {
    label: 'Any',
    value: 'any',
  },
];

type HasPaymentLinkSelectProps = {
  value: TriStateFilter;
  onChange: (value: TriStateFilter) => void;
};

function HasPaymentLinkSelect({ value, onChange }: HasPaymentLinkSelectProps) {
  return (
    <CoreFormFieldSelect
      inputProps={{ id: 'has-payment-link-filter' }}
      options={options}
      value={options.find((option) => option.value === value)}
      onChange={(option) => {
        onChange(option.value);
      }}
      label="Filter invoices that have a payment link"
    />
  );
}

type HasPaymentLinkWithEmailSelectProps = {
  value: TriStateFilter;
  onChange: (value: TriStateFilter) => void;
};

function HasPaymentLinkWithEmailSelect({
  value,
  onChange,
}: HasPaymentLinkWithEmailSelectProps) {
  return (
    <CoreFormFieldSelect
      inputProps={{ id: 'has-payment-link-with-email-filter' }}
      options={options}
      value={options.find((option) => option.value === value)}
      onChange={(option) => {
        onChange(option.value);
      }}
      label="Filter invoices that have a payment link, and that have been emailed"
    />
  );
}
